import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';

const { primaryMotivationForSolar, projectType } = loanFormModel.formField;

export class PrimaryMotivationForSolarValidation implements ValidationSchema {
  public name = primaryMotivationForSolar.name;
  public label = primaryMotivationForSolar.label;
  public type = 'string';
  public dependsOn: string[] = [projectType.name];

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;

  public when(
    projectType: string | null | undefined,
    schema: Yup.StringSchema
  ) {
    const projectTypeNormalized = projectType?.toLowerCase() ?? '';
    if (
      !primaryMotivationForSolar.allowedProjectTypes.includes(
        projectTypeNormalized
      )
    ) {
      return schema.optional().nullable();
    }
    return schema.required('This field is required');
  }
}
export default new Validation(new PrimaryMotivationForSolarValidation());
